var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button, Tooltip, withStyles } from '@material-ui/core';
import moment from 'moment';
import React, { useMemo } from 'react';
import { language, pluralizeDays, pluralizeHours, _T } from '../../../../../include/appI18n';
import appSettings from '../../../../../include/appSettings';
import { api } from '../../../../../include/network/network';
import { formatMoney } from '../../../../../include/utils';
import { useFlightConfiguration, useTourDescriptionStore } from '../../../store/TourDescriptionStore';
import { isCapitalUI } from '../../../../../include/react-common/theme';
import { CapitalFlightTariffCard } from '../../../../../include/react-components/capital/flight/CapitalFlight';
import { capitalFlightAssetBaseUrl, capitalFlightLabels } from './CapitalFlightAdapter';
const AltTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        borderRadius: 0,
        fontSize: 12.5,
        fontFamily: "'Play', sans-serif !important",
        width: '180px',
        padding: '6px',
        marginTop: '2px',
    },
    arrow: {
        color: theme.palette.grey["400"],
    },
}))(Tooltip);
export const FlightAltVariant = ({ isCurrent, variant, onSelect, group, isFrame, onAltMoreDetailed, currentInGroup }) => {
    const [{ flightConfiguration }] = useFlightConfiguration(isFrame);
    const [{ hash, tourDescription }, actions] = useTourDescriptionStore(isFrame);
    const showFlightDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        actions.enableFlightLoading();
        try {
            var { response: data, errors } = yield api('post', `/tour/flights/details/${hash}`, {
                aviacenterProviderId: variant.providerId,
                aviacenterFlightId: variant.flightId,
            });
            if (isCapitalUI && (errors === null || errors === void 0 ? void 0 : errors.length))
                throw new Error('Could not load flight conditions');
            onAltMoreDetailed(React.createElement(React.Fragment, null,
                !isCapitalUI ? React.createElement("div", { className: "d-flex" },
                    React.createElement("h2", { className: "flex-1" }, _T.FLIGHT_SEARCH_MORE_DETAILS_FLIGHT_INFO),
                    React.createElement("div", { className: "dismisser", "data-dismiss": "modal", onClick: () => onAltMoreDetailed(undefined) }, "\u00D7")) : null,
                !(data === null || data === void 0 ? void 0 : data.length) ? React.createElement(React.Fragment, null, _T.FLIGHT_SEARCH_MORE_DETAILS_FLIGHT_NO_INFO) : React.createElement(React.Fragment, null, data.map(d => (React.createElement(React.Fragment, null,
                    React.createElement("h4", { className: "mt-4" },
                        React.createElement("span", null, d.departure),
                        " \u2013 ",
                        React.createElement("span", null, d.arrival)),
                    React.createElement("pre", { dangerouslySetInnerHTML: { __html: d.description } })))))));
        }
        catch (error) {
            console.error('Could not load flight conditions', error);
            if (isCapitalUI)
                onAltMoreDetailed(React.createElement("div", { role: "alert" },
                    React.createElement("p", null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS_LOADING_FAILED),
                    React.createElement(Button, { color: "primary", variant: "outlined", onClick: () => { void showFlightDetails(); } }, (language === null || language === void 0 ? void 0 : language.toLowerCase().startsWith('en')) ? 'Try again' : 'Повторить')));
        }
        finally {
            actions.disableFlightLoading();
        }
    });
    const remainingPaymentTimeframeText = useMemo(() => {
        if (!variant.paymentDeadline)
            return undefined;
        const diff = Math.max(1, moment(variant.paymentDeadline).diff(moment.utc()));
        const duration = moment.duration(diff);
        const hours = Math.floor(duration.asHours());
        if (hours >= 48) {
            const days = Math.floor(duration.asDays());
            return `${days} ${pluralizeDays(days)}`;
        }
        else if (hours >= 1) {
            return `${hours} ${pluralizeHours(hours)}`;
        }
        return _T.FLIGHT_SEARCH_LESS_THEN_HOUR;
    }, [variant.paymentDeadline]);
    if (isCapitalUI) {
        const inRubles = appSettings().tourMainPriceCurrency == 1 && variant.flightCostDifferenceRub !== null && variant.flightCostDifferenceRub !== undefined;
        const difference = inRubles ? variant.flightCostDifferenceRub : variant.flightCostDifference;
        const currency = inRubles ? 'RUB' : variant.flightCostCurrency;
        return React.createElement(CapitalFlightTariffCard, { variant: variant, labels: capitalFlightLabels, assetBaseUrl: capitalFlightAssetBaseUrl, selected: isCurrent, onSelect: () => onSelect(variant), onDetails: () => { void showFlightDetails(); }, paymentLabel: flightConfiguration.showExactTimeLimit ? _T.FLIGHT_SEARCH_PAYMENT_BEFORE : _T.FLIGHT_SEARCH_TIMES_FOR_PAYMENT, paymentText: remainingPaymentTimeframeText ? flightConfiguration.showExactTimeLimit ? moment(variant.paymentDeadline).format('DD.MM.YYYY HH:mm') : remainingPaymentTimeframeText : undefined, paymentHint: variant.paymentDeadline ? `${_T.FLIGHT_SEARCH_PAYMENT_AVAILABLE_BEFORE} ${moment(variant.paymentDeadline).format('DD.MM.YYYY HH:mm')}` : undefined, price: React.createElement(React.Fragment, null,
                difference > 0 ? '+' : difference < 0 ? '−' : '',
                formatMoney(Math.abs(difference), { localeAware: true, currency }),
                " ",
                currency) });
    }
    return (React.createElement("div", { className: `alt-variant${isCurrent ? ' active' : ''}`, onClick: (e) => {
            e.stopPropagation();
            onSelect(variant);
        } },
        React.createElement("div", { className: "alt-variant-title" },
            React.createElement("span", null, variant.forwardStops[0].airServiceClassName),
            "\u00A0",
            variant.airServiceGeneralClass ? React.createElement(React.Fragment, null,
                "(",
                React.createElement("span", null, variant.airServiceGeneralClass),
                ")") : null),
        React.createElement("div", { className: "alt-variant-main" },
            React.createElement("div", { className: "alt-variant-conditions" },
                React.createElement("div", null, variant.maxHandBaggageCount
                    ? React.createElement("span", { className: "flight-icon-on hand-on" },
                        "x",
                        React.createElement("span", null, variant.maxHandBaggageCount))
                    : React.createElement("span", { className: "flight-icon-off hand-off" })),
                React.createElement("div", null, variant.maxBaggageCount
                    ? React.createElement("span", { className: "flight-icon-on baggage-on" },
                        "x",
                        React.createElement("span", null, variant.maxBaggageCount))
                    : React.createElement("span", { className: "flight-icon-off baggage-off" })),
                React.createElement("div", null, variant.isTicketRefundable
                    ? React.createElement("span", { className: "flight-icon-on refund-on" })
                    : React.createElement("span", { className: "flight-icon-off refund-off" })),
                React.createElement("div", null, variant.isTicketExchangeable
                    ? React.createElement("span", { className: "flight-icon-on exchange-on" })
                    : React.createElement("span", { className: "flight-icon-off exchange-off" })))),
        React.createElement("div", { className: "alt-variant-flight-timer" }, remainingPaymentTimeframeText ? React.createElement(React.Fragment, null, flightConfiguration.showExactTimeLimit ?
            React.createElement(AltTooltip, { arrow: true, title: `${remainingPaymentTimeframeText} ${_T.FLIGHT_SEARCH_TIMES_FOR_PAYMENT}` },
                React.createElement(Button, { fullWidth: true, disableElevation: true, disableRipple: true, disableTouchRipple: true, disableFocusRipple: true, className: "tooltip-btn" },
                    React.createElement("div", { className: "small brand-gray" }, _T.FLIGHT_SEARCH_PAYMENT_BEFORE),
                    React.createElement("div", { className: "nobr" }, moment(variant.paymentDeadline).format('DD.MM.YYYY HH:mm')))) :
            React.createElement(AltTooltip, { arrow: true, title: `${_T.FLIGHT_SEARCH_PAYMENT_AVAILABLE_BEFORE} ${moment(variant.paymentDeadline).format('DD.MM.YYYY HH:mm')}` },
                React.createElement(Button, { fullWidth: true, disableElevation: true, disableRipple: true, disableTouchRipple: true, disableFocusRipple: true, className: "tooltip-btn" },
                    React.createElement("div", { className: "nobr" }, remainingPaymentTimeframeText),
                    React.createElement("div", { className: "small brand-gray" }, _T.FLIGHT_SEARCH_TIMES_FOR_PAYMENT)))) : null),
        React.createElement("div", { className: "alt-variant-flight-details" },
            React.createElement("span", { onClick: (e) => {
                    e.stopPropagation();
                    showFlightDetails();
                } }, _T.FLIGHT_SEARCH_MORE_DETAILS)),
        React.createElement("div", { className: "alt-variant-price" }, appSettings().tourMainPriceCurrency == 1 && variant.flightCostDifferenceRub !== null && variant.flightCostDifferenceRub !== undefined
            ? React.createElement("span", { className: "money nobr" },
                React.createElement("span", null, variant.flightCostDifference > 0 ? '+' : variant.flightCostDifferenceRub < 0 ? '-' : ''),
                React.createElement("span", null, formatMoney(Math.abs(variant.flightCostDifferenceRub), { localeAware: true, currency: "RUB" })),
                " ",
                React.createElement("span", null, "RUB"))
            : React.createElement("span", { className: "money nobr" },
                React.createElement("span", null, variant.flightCostDifference > 0 ? '+' : variant.flightCostDifference < 0 ? '-' : ''),
                React.createElement("span", null, formatMoney(Math.abs(variant.flightCostDifference), { localeAware: true, currency: tourDescription.currency.name })),
                " ",
                React.createElement("span", null, variant.flightCostCurrency)))));
};
